import { AnchorContext, AnchorContextModel } from "@store/Framework/Components/AnchorContext/AnchorContext";
import React, { FC, useMemo, useState } from "react";

export const AnchorContextProvider: FC<{ children?: React.ReactNode }> = ({ children }) => {
    const [links, setLinks] = useState<AnchorContextModel["links"]>([]);

    return (
        <AnchorContext.Provider
            value={{
                links,
                setLinks,
            }}
        >
            {children}
        </AnchorContext.Provider>
    );
};
